import {ApiExecutor} from "./api/executor";
import {buildUrl} from "./util/browserUtil";

/**
 * Access to the two APIs: builds the request URLs from path segments and holds the executor that
 * runs the requests. Individual endpoints are described by the classes under `api/interface`, which
 * receive this instance in `execute()`.
 */
export default class ServiceApi {
    readonly revaApiUrl: string;
    readonly avmApiUrl: string;

    readonly executor: ApiExecutor = new ApiExecutor();

    /**
     * Create service API.
     * @param revaApiUrl the base URL of the REVA API proxy in the backend server
     * @param avmApiUrl the base URL of the AVM API proxy in the backend server
     * @constructor
     */
    constructor(revaApiUrl: string, avmApiUrl: string) {
        this.revaApiUrl = revaApiUrl;
        this.avmApiUrl = avmApiUrl;
    }

    /**
     * Construct REVA API URL.
     * @param pathSegments path segments for the URL (relative to REVA API base URL)
     * @param queryParams optional query params (null or undefined values will be ignored)
     */
    buildRevaApiUrl(pathSegments: string[], queryParams?: Record<string, any> | null): string {
        return buildUrl(this.revaApiUrl, pathSegments, queryParams);
    }

    /**
     * Construct AVM API URL.
     * @param pathSegments path segments for the URL (relative to AVM API base URL)
     * @param queryParams optional query params (null or undefined values will be ignored)
     */
    buildAvmApiUrl(pathSegments: string[], queryParams?: Record<string, any> | null): string {
        return buildUrl(this.avmApiUrl, pathSegments, queryParams);
    }
}
